import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTask } from '../contexts/TaskContext';
import SpaceDashboard from '../components/SpaceDashboard';

const SpaceDashboardPage = () => {
    const { spaceId } = useParams();
    const { setActiveView, setSelectedProjectId } = useTask();

    useEffect(() => {
        setActiveView('space-dashboard');
        if (spaceId) {
            setSelectedProjectId(spaceId);
        }
    }, [spaceId, setActiveView, setSelectedProjectId]);

    return <SpaceDashboard spaceId={spaceId} />;
};

export default SpaceDashboardPage;
